import { Box, Grid2, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { colors } from "../../theme/theme";
import SingleVideo from "../HomePage/SingleVideo";
import SingleCreator from "./SingleCreator";
import axiosInstance from "../../utils/config/config";
import { useSelector } from "react-redux";

const TrainingPlans = ({ title, type, allData, fetchUserPosts }) => {
  const [creators, setCreators] = useState(null);
  const { userData } = useSelector((state) => state.user);
  const mediumScreen = useMediaQuery("(max-width:900px)");
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const fetchAllCreators = async () => {
    try {
      const creatorReesponse = await axiosInstance.get("/user/getAllCreators");

      setCreators(creatorReesponse.data.creators);
    } catch (err) {
      console.log(err);
    }
  };

  const data = [
    {
      id: 1,
      src: require("../../assets/images/content-image1.png"),
      alt: "Image 1",
      creator: false,
    },
    {
      id: 2,
      title: "John Smith",
      followers: "10k",
      tags: "BJJ Black Belt",
      desc: "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
      creator: true,
      src: require("../../assets/images/content-image4.png"),
      alt: "Image 2",
      achievements: ["2x World Champion", "ADCC Competitor"],
    },
    {
      id: 3,
      src: require("../../assets/images/content-image2.png"),
      alt: "Image 4",
    },
    {
      id: 4,
      src: require("../../assets/images/content-image5.png"),
      alt: "Image 5",
    },
    {
      id: 5,
      title: "Natasha Moris",
      followers: "10k",
      tags: "Muay Thai Coach",
      desc: "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
      src: require("../../assets/images/creator1.png"),
      alt: "Image 3",
      creator: true,
      achievements: ["2x World Champion", "ADCC Competitor"],
    },
    {
      id: 6,
      src: require("../../assets/images/content-image6.png"),
      alt: "Image 6",
    },
    {
      id: 7,
      src: require("../../assets/images/content-image4.png"),
      alt: "Image 7",
    },
    {
      id: 8,
      title: "Knoll Mara",
      tags: "Wrestling Olympian",
      followers: "10k",
      desc: "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
      src: require("../../assets/images/creator2.png"),
      alt: "Image 8",
      creator: true,
      achievements: ["2x World Champion", "ADCC Competitor"],
    },
  ];

  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
  const videoRefs = useRef([]);

  const handlePlayPause = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });

    if (currentPlayingIndex === index) {
      videoRefs.current[index].pause();
      setCurrentPlayingIndex(null);
    } else {
      videoRefs.current[index].play();
      setCurrentPlayingIndex(index);
    }
  };

  useEffect(() => {
    fetchAllCreators();
  }, []);

  return (
    <Box
      sx={{
        mt: 4,
      }}
    >
      <Typography
        sx={{
          fontSize: "23px",
          fontFamily: "Inter-Bold",
          color: colors.textColor,
        }}
      >
        {title}
      </Typography>

      {allData?.length === 0 && (
        <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Box
            sx={{
              width: "100%",
              height: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <img
              src={require("../../assets/icons/no-results.png")}
              style={{
                height: "50px",
                width: "50px",
              }}
              alt="no-content"
            />
            <Typography
              sx={{
                fontFamily: "Inter-SemiBold",
                fontSize: "24px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {title === "Paid Videos"
                ? "You have not subscribed to any content yet!"
                : title === "My Videos"
                ? "You have not uploaded any content yet!"
                : title === "Training Plans"
                ? "This creator has not created any training plans"
                : "You have not subscribed to any creator yet!"}
            </Typography>
          </Box>
        </Grid2>
      )}

      {type === "videos" && (
        <Grid2 container spacing={2} sx={{ pt: 2 }}>
          {allData &&
            allData?.map((item, index) => (
              <Grid2
                item
                key={index}
                size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                sx={{ position: "relative" }}
              >
                <SingleVideo
                  item={title === "Paid Videos" ? item?.content : item}
                  index={index}
                  videoRef={(ref) => (videoRefs.current[index] = ref)}
                  onPlayPause={() => handlePlayPause(index)}
                  isPlaying={currentPlayingIndex === index}
                  smallPlayBtn
                  borderRadius
                  noCreator
                  paid={
                    userData.subscribed.some(
                      (i) => i?.creatorId === item?.creator?.id
                    ) || userData.role === "admin"
                  }
                  fetchUserPosts={fetchUserPosts}
                />
              </Grid2>
            ))}
        </Grid2>
      )}

      {type === "creators" && (
        <Grid2 container spacing={2} sx={{ pt: 2 }}>
          {creators.map((item, index) => (
            <Grid2
              item
              key={index}
              size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
              sx={{
                position: "relative",
                overflow: "hidden",
                "&:hover .overlay": {
                  opacity: 1,
                },
              }}
            >
              <SingleCreator item={item} />
            </Grid2>
          ))}
        </Grid2>
      )}
      {type === "training" && (
        <Grid2 container spacing={2} sx={{ pt: 2 }}>
          {allData.map((item, index) => (
            <Grid2
              item
              key={index}
              size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
              sx={{
                position: "relative",
                overflow: "hidden",
                "&:hover .overlay": {
                  opacity: 1,
                },
              }}
            >
              <Box>
                <img
                  src={
                    item?.mediaURL || require("../../assets/images/user.jpg")
                  }
                  alt="content"
                  style={{
                    width: "100%",
                    height: smallScreen ? "100px" : "240px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />

                <Box sx={{ pt: 1 }}>
                  <Typography
                    sx={{
                      color: colors.textColor,
                      fontSize: smallScreen ? "18px" : "22px",
                      fontFamily: "Inter-SemiBold",
                      cursor: "pointer",
                    }}
                  >
                    {item?.name}
                  </Typography>

                  <Typography
                    sx={{
                      mt: 1,
                      color: "#00000080",
                      fontSize: "13px",
                      fontFamily: "Inter-Regular",
                      overflow: "hidden",
                      display: "-webkit-box", // ✅ REQUIRED for WebkitLineClamp
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: mediumScreen ? 2 : 2, // ✅ Works properly now
                      textOverflow: "ellipsis",
                      wordBreak: "break-word", // Prevents breaking long words incorrectly
                    }}
                  >
                    {item?.description}
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          ))}
        </Grid2>
      )}
    </Box>
  );
};

export default TrainingPlans;
